import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colorVariables } from '../../../../styles/colorVariables';
import { Sizes } from '../../../../styles/sizes';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalBox: {
      padding: '40px 30px',
    },
    modalContent: {
      textAlign: 'center',
      '& h2': {
        fontSize: 20,
        fontWeight: 700,
        color: colorVariables.navy,
      }
    },
    subTitle: {
      fontSize: 14,
      fontWeight: 400,
      color: colorVariables.navy,
    },
    heading: {
      margin: 0,
      fontSize: 24,
      fontWeight: 700,
      textAlign: 'center',
      color: colorVariables.navy,
    },
    subheading: {
      textAlign: 'center',
      color: '#666',
      marginBottom: 24,
    },
    searchBox: {
      background: 'rgba(152, 165, 183, 0.15)',
      borderRadius: 4,
      padding: '8px 12px',
      margin: '16px 0',
      [theme.breakpoints.down(Sizes.mobile)]: {
        margin: '8px 0',
      },
    },
    searchInput: {
      width: '100%',
      padding: '1px 4px',
      border: '1px solid #CFD7E6',
      borderRadius: 2,
      fontSize: 14,
      backgroundColor: '#fff',
    },
    searchIcon: {
      color: colorVariables.grey60,
    },
     noUnderline: {
      '&:before': {
        borderBottom: 'none',
      },
      '&:hover:not(.Mui-disabled):before': {
        borderBottom: 'none',
      },
      '&:after': {
        borderBottom: 'none',
      },
    },
    tabs: {
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: '1px solid #e0e0e0',
      marginBottom: 12,
      marginTop: 12,
    },
    tab: {
      width: '50%',
      textAlign: 'center',
      paddingBottom: 8,
      fontWeight: 400,
      fontSize: 14,
      color: colorVariables.navy,
      cursor: 'pointer',
    },
    active: {
      borderBottom: '2px solid #33dbc3',
      fontWeight: 700,
      color: colorVariables.navy,
    },
    userList: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      height: 332,
      overflowY: 'auto',
      padding: '0 6px',
      [theme.breakpoints.down(Sizes.mobile)]: {
        height: 230,
      },
    },
    userCard: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      border: '1px solid #CFD7E6',
      borderRadius: 4,
      padding: 10,
      cursor: 'pointer',
      gap: 0,
    },
    selected: {
      border: '1px solid #33A8E2',
    },
    userInfo: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'left',
      flex: 1,
      '& strong': {
        fontWeight: 600,
        fontSize: 14,
        color: colorVariables.navy,
        marginBottom: 4,
      },
      '& .location': {
        height: 15,
        fontWeight: 400,
        fontSize: 11,
        color: colorVariables.grey80,
      },
    },
    logo: {
      width: 36,
      height: 36,
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        borderRadius: '50%',
      },
    },
    footer: {
      borderTop: '1px solid #98A5B7',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: 20,
      marginTop: 10,
      [theme.breakpoints.down(Sizes.mobile)]: {
        paddingTop: 10,
        flexDirection: 'column',
      },
    },
    footerText: {
      fontWeight: 600,
      fontSize: 14,
      color: colorVariables.navy,
      width: 200,
      textAlign: 'left',
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: '100%',
        paddingBottom: 10,
      },
    },
    actions: {
      [theme.breakpoints.down(Sizes.mobile)]: {
        flexDirection: 'row',
      },
    },
    cancelButton: {
      background: '#e6ebf5',
      color: colorVariables.navy,
      padding: '8px 16px',
      borderRadius: 20,
      fontWeight: 600,
      border: 'none',
      cursor: 'pointer',
    },
    applyButton: {
      background: colorVariables.grey10,
      color: '#fff',
      padding: '8px 16px',
      borderRadius: 20,
      fontWeight: 600,
      border: 'none',
      cursor: 'pointer',
    },
    noResultText: {
      padding: 16,
      textAlign: 'center',
      color: '#888',
      fontStyle: 'italic',
    }
  })
);
